import { render, staticRenderFns } from "./zhiniugu.vue?vue&type=template&id=5b31ad55&scoped=true"
import script from "./zhiniugu.vue?vue&type=script&lang=js"
export * from "./zhiniugu.vue?vue&type=script&lang=js"
import style0 from "./zhiniugu.vue?vue&type=style&index=0&id=5b31ad55&prod&lang=scss"
import style1 from "./zhiniugu.vue?vue&type=style&index=1&id=5b31ad55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b31ad55",
  null
  
)

export default component.exports